export default "__VITE_ASSET__fuVMkNDz__"